<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f u-jsb " :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="title" placeholder="请输入内容" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="status_value" placeholder="请选择" clearable size="small">
                            <el-option v-for="item in status_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="real_name" label="真实姓名" width="80"> </el-table-column>
                <el-table-column prop="examine_text" label="头像" width="100">
                    <template slot-scope="scope" v-if="scope.row.head_portrait_pic">
                        <el-image style="width: 80px; height: 80px" :src="scope.row.head_portrait_pic[0].url"
                            :preview-src-list="[scope.row.head_portrait_pic[0].url]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" width="120"> </el-table-column>
                <el-table-column prop="identity_card" label="身份证号" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="email" label="电子邮箱" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="competent_id_text" label="职称" show-overflow-tooltip width="100">
                </el-table-column>
                <el-table-column prop="good_at" label="擅长" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examine_text" label="审核状态" width="100">
                    <template slot-scope="scope">
                        <div :class="scope.row.examine==1?'greens':'reds'">
                            {{scope.row.examine_text}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="审核" width="430" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleExamine(scope.$index, scope.row)">审核
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!--  -->
        <el-dialog title="入驻审核" :visible.sync="dialogs" top="80px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="demo-ruleForm">
                    <el-form-item label="审核:">
                        <el-radio-group v-model="form.examine">
                            <el-radio :label="1">通过</el-radio>
                            <el-radio :label="2">未通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-if="form.examine=='2'">
                        <el-form-item label="拒绝理由" prop="result">
                            <el-input size="small" v-model="form.result" type="textarea" :rows="4"></el-input>
                        </el-form-item>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="身份证:">
                                <div v-if="jbxxItem&&jbxxItem.identity_card_pic" class="u-f u-wrap">
                                    <div v-for="(item,index) in  jbxxItem.identity_card_pic" :key="index" class="img_pd"
                                        @click="goprev(item)">
                                        <img :src="item.url" alt="" width="100" height="100">
                                    </div>
                                </div>
                            </el-form-item>
                            <el-form-item label="医师执业证书:">
                                <div v-if="jbxxItem&&jbxxItem.psy_counseling_pic.length>0" class="u-f u-wrap">
                                    <div v-for="(item,index) in  jbxxItem.psy_counseling_pic" :key="index"
                                        class="img_pd" @click="goprev(item)">
                                        <img :src="item.url" alt="" width="100" height="100">
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit('form')" size="small">确 定</el-button>
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>


        <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="urls" class="w-100" />
            </div>
        </el-dialog>


        <!--编辑  -->
        <el-dialog title="编辑" :visible.sync="dialog_info" width="80%" center top="5vh">
            <div class="dialog-ibox-content">
                <el-form ref="formed" :model="formed" label-width="140px" :rules="rule" class="forms-inlines">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="真实姓名" prop="username">
                                <el-input v-model="formed.username" placeholder="真实姓名" size="small">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="身份证号码" prop="userId">
                                <el-input v-model="formed.userId" placeholder="身份证号码" size="small">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="手机号码" prop="phone">
                                <el-input v-model="formed.phone" placeholder="手机号码" size="small">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="职称" prop="doctitle">
                                <el-cascader v-model="formed.doctitle" size="small"
                                    :props="{ value: 'id', label: 'name',  }" :options="doctitle_options"
                                    @change="doctitleChange"></el-cascader>
                            </el-form-item>
                            <el-form-item label="科室" prop="department">
                                <el-cascader v-model="formed.department" size="small"
                                    :props="{ value: 'id', label: 'name',  }" :options="depat_options"
                                    @change="depatChange">
                                </el-cascader>
                            </el-form-item>
                            <el-form-item label="简介" prop="brief">
                                <el-input type="textarea" :autosize="false" resize="none" :rows="3" placeholder="请输入简介"
                                    v-model="formed.brief">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="擅长" prop="goodat">
                                <el-input type="textarea" :autosize="false" resize="none" :rows="3" placeholder="请输入擅长"
                                    v-model="formed.goodat">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="好评率" prop="goodnum">
                                <el-input v-model="formed.goodnum" placeholder="好评率%" size="mini">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="服务患者数量" prop="servicenum">
                                <el-input v-model="formed.servicenum" placeholder="服务患者数量" size="mini">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="完成问诊咨询" prop="doneuser">
                                <el-input v-model="formed.doneuser" placeholder="完成问诊咨询" size="mini">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="图文咨询费用" prop="tw_mon">
                                <el-input v-model="formed.tw_mon" placeholder="元" type="number" size="mini" min="0">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="语音咨询费用" prop="yy_mon">
                                <el-input v-model="formed.yy_mon" placeholder="元" type="number" size="mini" min="0">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="视频咨询费用" prop="sp_mon">
                                <el-input v-model="formed.sp_mon" placeholder="元" type="number" size="mini" min="0">
                                </el-input>
                            </el-form-item>

                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="头像" prop="tx_mapList">
                                <el-upload class="avatar-uploader" :limit="1" action="/admin/uploadFile" name="img"
                                    ref="upload" :headers="{ token:$store.state.user.token }"
                                    :data="{ image_class_id:'53',file_type:'1' }" :file-list="formed.tx_mapList"
                                    :on-success="handleAvatarSuccess" :on-remove="uploadRmove" list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="身份证图片" prop="id_mapList">
                                <el-upload class="avatar-uploader" :limit="2" action="/admin/uploadFile" name="img"
                                    ref="upload" :headers="{ token:$store.state.user.token }"
                                    :data="{ image_class_id:'53',file_type:'1' }" :file-list="formed.id_mapList"
                                    :on-success="handleAvatarSuccess2" :on-remove="uploadRmove2"
                                    list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="心理咨询师证书" prop="zyzs_mapList">
                                <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                    :headers="{ token:$store.state.user.token }"
                                    :data="{ image_class_id:'53',file_type:'1' }" :file-list="formed.zyzs_mapList"
                                    :on-success="handleAvatarSuccess3" :on-remove="uploadRmove3"
                                    list-type="picture-card">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="editSubmit('formed')" size="small">确 定</el-button>
                <el-button @click="dialog_info = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import invitable from '../../../components/settle/table'
    export default {
        components: {
            invitable
        },
        data() {
            return {
                // 头像
                imageUrl: '',
                status_options: [{
                    id: 0,
                    name: '待审'
                }, {
                    id: 1,
                    name: '通过'
                }, {
                    id: 2,
                    name: '未通过'
                }],
                status_value: '',
                dialog: false,
                dialog_info: false,
                title: '',
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                depat_options: [],
                doctitle_options: [],
                hos_options: [],

                // 
                eid: '',
                userinfoid: '',
                userid: '',
                dialogs: false,
                form: {
                    examine: '',
                    result: '',
                },
                formed: {
                    doctitle: [],
                    department: [],
                    hospital: '',
                    email: '',
                    userId: '',
                    phone: '',
                    username: '',
                    goodat: '',
                    brief: '',
                    zyzs_mapList: [],
                    id_mapList: [],
                    tx_mapList: [],
                    doneuser: '',
                    servicenum: '',
                    goodnum: '',
                    tw_mon: 0,
                    yy_mon: 0,
                    sp_mon: 0,
                },
                doctitids: '',
                doctitid: '',
                departids: '',
                departid: '',
                mapListed: [],
                mapListed2: [],
                mapListed3: [],
                rule: {
                    result: [{
                        required: true,
                        message: '请填写拒绝通过的理由',
                        trigger: 'blur'
                    }],
                    doctitle: [{
                        required: true,
                        message: '请选择职称',
                        trigger: 'blur'
                    }],
                    department: [{
                        required: true,
                        message: '请选择科室',
                        trigger: 'blur'
                    }],
                    userId: [{
                        required: true,
                        message: '请填写身份证号码',
                        trigger: 'blur'
                    }],
                    phone: [{
                        required: true,
                        message: '请填写手机号码',
                        trigger: 'blur'
                    }],
                    username: [{
                        required: true,
                        message: '请填写真实姓名',
                        trigger: 'blur'
                    }],
                    goodat: [{
                        required: true,
                        message: '请填写擅长',
                        trigger: 'blur'
                    }],
                    brief: [{
                        required: true,
                        message: '请填写简介',
                        trigger: 'blur'
                    }],


                    zyzs_mapList: [{
                        required: true,
                        message: '请添加职业证书',
                        trigger: 'blur'
                    }],
                    id_mapList: [{
                        required: true,
                        message: '请添加身份证照片',
                        trigger: 'blur'
                    }],
                    tx_mapList: [{
                        required: true,
                        message: '请添加头像',
                        trigger: 'blur'
                    }],
                    doneuser: [{
                        required: true,
                        message: '请输入完成用户名',
                        trigger: 'blur'
                    }],
                    servicenum: [{
                        required: true,
                        message: '请输入服务数量',
                        trigger: 'blur'
                    }],
                    goodnum: [{
                        required: true,
                        message: '请输入好评率',
                        trigger: 'blur'
                    }],
                    tw_mon: [{
                        required: true,
                        message: '请设置图文咨询费用',
                        trigger: 'blur'
                    }],
                    yy_mon: [{
                        required: true,
                        message: '请设置语音咨询费用',
                        trigger: 'blur'
                    }],
                    sp_mon: [{
                        required: true,
                        message: '请设置视频咨询费用',
                        trigger: 'blur'
                    }],
                },
                // 
                dialog_prev: false,
                urls: '',
                jbxxItem: '',
                // 
                dialog_invite: false,
                invitindex: 0,
                doc_id: '',
                dialogCode: false,
                bdcode: '',
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
            this.getdoctit()
            this.getdepart()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 200 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/TalentAudit/index", {
                        // examine: that.status_value,
                        keyword: that.title,
                        page: that.currentPage,
                        page_count: that.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/pc/TalentAudit/ExamineData", {
                                id: that.eid,
                                examine: that.form.examine,
                                examine_result: that.form.result,
                                author: that.user.id
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    if (this.form.examine == 1) {
                                        this.getpoint()
                                    }
                                    that.dialogs = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            // 积分
            getpoint() {
                axios
                    .post("/admin/Kcurrency/KcurrencyRecord", {
                        action: 18,
                        type: 1,
                        data_id: this.jbxxItem.id,
                        source: 6,
                        modular: 6,
                        userId: this.jbxxItem.user_id
                    }, {
                        token: true
                    })
                    .then(response => {})
                    .catch(error => {})
            },
            editSubmit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        axios
                            .post("/admin/pc/TalentAudit/ExamineData", {
                                id: that.eid,
                                user_id: that.userid, // 账号id 登录信息里的id
                                // user_info_id: that.userinfoid, //基本信息id 登录信息里userinfo里的id
                                real_name: that.formed.username, //申请人姓名
                                identity_card: that.formed.userId, //身份证号
                                phone: that.formed.phone, //手机号
                                consultation_log: that.formed.doneuser, //完成咨询人
                                service_count: that.formed.servicenum, //服务数量
                                praise: that.formed.goodnum, //好评率
                                department_id: that.departid, //科室id
                                department_ids: that.departids, // 所选科室第一级id拼接第二级id 入 32,33
                                competent_id: that.doctitid, //职称id
                                competent_ids: that.doctitids, //职称层级id 如1,2
                                identity_card_pic: that.mapListed2, //身份证图片
                                head_portrait_pic: that.mapListed, //头像图片
                                psy_counseling_pic: that.mapListed3, //医师执业证书
                                // examine: that.form.examine,
                                // examine_result: that.form.result,
                                good_at: that.formed.goodat, //擅长
                                introduction: that.formed.brief, //介绍
                                author: that.user.id,
                                picture_consultation: that.formed.tw_mon,
                                voice_consultation:   that.formed.yy_mon,
                                video_consultation:   that.formed.sp_mon,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.dialog_info = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });

                                } else {
                                    that.$message.error(response.data.message);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleExamine(index, row) {
                let that = this
                that.dialogs = true
                this.jbxxItem = ''
                that.eid = row.id
                that.clear()
                axios
                    .post("/admin/pc/TalentAudit/readExamine", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {

                        var data = response.data.data
                        if (data) {
                            this.jbxxItem = response.data.data
                            that.form.examine = data.examine
                            that.form.result = data.examine == '1' ? '' : data.examine_result
                        } else {
                            that.eid = ''
                        }
                    })
                    .catch(error => {})
            },
            handleEdit(index, row) {
                let that = this
                this.eid = row.id
                this.userid = row.user_id
                this.userinfoid = row.user_info_id
                this.examine = row.examine

                this.jbxxItem = ''
                that.clear()
                axios
                    .post("/admin/pc/TalentAudit/readExamine", {
                        id: that.eid
                    }, {
                        token: true
                    })
                    .then(response => {

                        var data = response.data.data
                        if (data) {
                            // that.form.examine = data.examine
                            // that.form.result = data.examine == '1' ? '' : data.examine_result
                        } else {
                            that.eid = ''
                        }
                        that.formed.tx_mapList = data.head_portrait_pic
                        that.mapListed = data.head_portrait_pic
                        that.formed.id_mapList = data.identity_card_pic
                        that.mapListed2 = data.identity_card_pic

                        that.formed.zyzs_mapList = data.psy_counseling_pic
                        that.mapListed3 = data.psy_counseling_pic


                        that.formed.goodat = data.good_at
                        that.formed.brief = data.introduction

                        that.formed.goodnum = data.praise
                        that.formed.servicenum = data.service_count
                        that.formed.doneuser = data.consultation_log

                        this.doctitid = data.competent_id
                        this.doctitids = data.competent_ids
                        this.formed.tw_mon=data.picture_consultation-0
                        this.formed.yy_mon=data.voice_consultation-0
                        this.formed.sp_mon=data.video_consultation-0

                    })
                    .catch(error => {})
                that.formed.department = row.department_ids ? row.department_ids.split(',').map(Number) : [] //科室id
                that.formed.doctitle = row.competent_ids ? row.competent_ids.split(',').map(Number) : [] //职称id
                that.formed.username = row.real_name //申请人姓名
                that.formed.userId = row.identity_card //身份证号
                that.formed.phone = row.phone //手机号



                that.dialog_info = true
            },
            clear() {
                let that = this
                that.form.examine = ''
                that.form.result = ''
            },
            goprev(item) {
                let that = this
                that.dialog_prev = true
                that.urls = item.url
            },
            handleDel(index, row) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/TalentAudit/delExamine", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.search()
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: response.data.msg
                                });
                            }
                        })
                        .catch(error => {})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doctitleChange(val) {
                this.doctitid = val[val.length - 1]
                this.doctitids = val.toString()
            },
            depatChange(val) {
                this.departid = val[val.length - 1]
                this.departids = val.toString()
            },

            // 获取职称
            getdoctit() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/showCompetentList", {
                        pid: 1
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        let obj = {}

                        let eles = []
                        response.data.data.forEach(ele => {
                            if (ele.children && ele.children.length > 0) {
                                let elechild = []
                                ele.children.forEach(e => {
                                    if (e.children.length == 0) {
                                        let obj = {}
                                        obj = {
                                            id: e.id,
                                            name: e.name
                                        }
                                        elechild.push(obj)
                                    }
                                })
                                let obj1 = {
                                    id: ele.id,
                                    name: ele.name,
                                    children: elechild
                                }
                                eles.push(obj1)
                            }
                        });
                        this.doctitle_options = eles
                    })
                    .catch(error => {})
            },
            // 获取科室
            getdepart() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/showSectionList", {
                        pid: 45
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false

                        let eles = []
                        response.data.data.forEach(ele => {
                            let elechild = []
                            if (ele.children && ele.children.length > 0) {

                                ele.children.forEach(e => {
                                    if (e.children.length == 0) {
                                        let obj = {}
                                        obj = {
                                            id: e.id,
                                            name: e.name
                                        }
                                        elechild.push(obj)
                                    }
                                })
                            }
                            let obj1 = {
                                id: ele.id,
                                name: ele.name,
                                children: elechild.length > 0 ? elechild : ''
                            }
                            eles.push(obj1)
                        });
                        this.depat_options = eles
                    })
                    .catch(error => {})
            },
            handleAvatarSuccess(res, file, fileList) {
                let that = this
                if (res.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(res.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(res.data)
            },
            handleAvatarSuccess2(res, file, fileList) {
                let that = this
                if (res.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(res.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed2.push(res.data)
            },
            handleAvatarSuccess3(res, file, fileList) {
                let that = this
                if (res.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(res.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed3.push(res.data)
            },


            uploadRmove(file, fileList) {

                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            uploadRmove2(file, fileList) {

                var index = this.mapListed2.findIndex(item => item.id == file.id)
                this.mapListed2.splice(index, 1)
            },
            uploadRmove3(file, fileList) {

                var index = this.mapListed3.findIndex(item => item.id == file.id)
                this.mapListed3.splice(index, 1)
            },
        },
    };
</script>
<style scoped>
    ::v-deep .el-dialog__body {
        padding-top: 0;
        padding-bottom: 0;
    }

    .img_pd {
        margin: 2px 5px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .codeImg {
        width: 70%;
        margin: 0 auto;
    }

    .codeImg img {
        width: 100%;
    }
</style>